import React, { useCallback } from 'react';
import { Grid, InputAdornment, Typography } from '@material-ui/core';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';
import UserIcon from '../../../icons/User';
import PasswordLockIcon from '../../../icons/PassWordLock';
import MainButton from '../../MUI/MainButton';
import { login } from '../../../redux/modules/auth';
import loginSchema from '../../../validations/auth/loginSchema';
import { closeLoginBlock, showForgotPass } from '../../../redux/modules/loginBlock';

import useStyles from './makeStyles';

const LoginForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const classes = useStyles();

  const { register, handleSubmit, errors, clearError } = useForm({
    validationSchema: loginSchema,
    mode: 'onSubmit',
  });

  const handleOpenForgotPassword = () => {
    dispatch(showForgotPass());
  };

  const goToSignUp = (e) => {
    e.preventDefault();
    dispatch(closeLoginBlock());
    history.replace('/sign-up');
  };

  const onSubmit = useCallback(
    (data) => {
      dispatch(login({ email: data.username, password: data.password }))
        .then(() => {
          dispatch(closeLoginBlock());
        })
        .catch(() => {});
    },
    [dispatch],
  );

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={11}>
        <Typography className={classes.headerText} align="center">
          {t('login.welcome')}
        </Typography>
        <Typography className={classes.subHeaderText} align="center">
          {t('login.pleaseLogin')}
        </Typography>
      </Grid>
      <Grid item xs={11}>
        <TextInputFieldWithValidation
          required
          formProps={{ errors, clearError }}
          placeholder={t('login.username')}
          name="username"
          register={register}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <UserIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={11}>
        <TextInputFieldWithValidation
          required
          type="password"
          formProps={{ errors, clearError }}
          placeholder={t('login.password')}
          name="password"
          register={register}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordLockIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={11}>
        <MainButton
          variant="contained"
          onClick={() => handleSubmit(onSubmit)()}
          className={classes.button}
          color="primary"
          width="fullWidth"
        >
          {t('login.login')}
        </MainButton>
      </Grid>
      <Grid item xs={11}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Typography
              align="center"
              className={classes.forgotPassword}
              onClick={handleOpenForgotPassword}
            >
              {t('login.forgotPassword')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.divider} />
          </Grid>
          <Grid item xs={11}>
            <Grid
              container
              alignItems="baseline"
              justifyContent="center"
              className={classes.newUser}
            >
              <Typography align="center" component="div" className={classes.newUserHeader}>
                {t('login.newUser')}
              </Typography>
              <Typography onClick={(e) => goToSignUp(e)} className={classes.signUp}>
                {t('login.signUp')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginForm;
